export default __webpack_public_path__ + "static/media/Group 79.dea378dc.png";